<ion-content class="bg-color ion-content apiCatalog">
  <div class="content-grid">
    <div class="main-content">
      <mat-card class="listing-card" [ngClass]="{'single-item': apiCatalog.length == 0 || apiCatalog.length == 1}">
        <mat-card-title class="cart-title">
          <span class="table-header">Marketplace Cart</span>
          <span class="close-button" (click)="closeModal()">
            <button mat-mini-fab disabled aria-label="Close Modal">
              <mat-icon>cancel</mat-icon>
            </button>
          </span>
        </mat-card-title>

        <mat-card-content class="cart-content" *ngIf="apiCatalog.length > 0 && loader">
          <div class="flex-container" *ngFor="let cat of apiCatalog">
            <mat-card class="main-section" style="margin-bottom: 10px;" (click)="selectedCartData(cat)">
              <div class="container">
                <div class="side">
                  <img [src]="'data:image/jpg;base64,' + cat.image">
                </div>

                <div class="main" *ngIf="loader" style="flex: 70%;">
                  <h1>{{cat.api_description}}</h1>
                  <div class="brand-info">
                    <span class="brand"> By {{cat.brand_name}} | {{cat.api_product_name}} |
                      {{cat.category_name}}</span>
                    <span class="type">Type: {{cat.type}}</span>
                  </div>
                  <h3> {{cat.api_business_object}} </h3>
                  <div class="method-info">
                    <div class="info-wrapper">
                      <span>Method: {{cat.method}}</span>
                    </div>
                    <div class="info-wrapper">
                      <span>Price & Deal: {{cat.price_type}}</span>
                    </div>
                  </div>
                </div>
                <div class="status" style="flex: 15%;max-height: 100%; overflow: hidden;display: flex; align-items: center;">
                  <button *ngIf="cat.isSelected == false" class="add-button"
                    (click)="selectedCartData(cat)">Add</button>
                  <button *ngIf="cat.isSelected" class="add-button" (click)="selectedCartData(cat)">Added</button>
                </div>
              </div>
            </mat-card>
          </div>
        </mat-card-content>
        <mat-card-content class="cart-error" *ngIf="apiCatalog.length === 0 && loader">
          <p class="search-result">
            No Results Found!
          </p>
          <p class="search-message">
            Add APIs to cart
          </p>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</ion-content>